import { axios } from '@/utils/request'

const api = {
  solution: '/solution/solution',
  sendEmail: '/solution/sendEmail'
}

export default api
// 新闻类型
export function getSolution(params) {
  return axios({
    url: api.solution,
    method: 'get',
    params
  })
}

export function deleteSolution(params) {
  return axios({
    url: api.solution,
    method: 'delete',
    params
  })
}

export function sendEmail(params) {
  return axios({
    url: api.sendEmail,
    method: 'get',
    params
  })
}
